import {
  Input,
  TextArea,
  CheckBox,
  Select,
  RichText,
  CheckboxGroup,
  TinyEditor,
  Tickbox,
  getNestedFieldStatus
} from "../components/EntryForm";
import { GetAppResource } from "../services/api/app";
import { GetTopicContentsList } from "../services/api/topic";
import { ReactComponent as DeleteIcon } from "../assets/icons/trash.svg";
import MediaUploader from "../components/MediaUploader";
import DataSelector from "../components/DataSelector";
import DateSelector from "../components/DateSelector";
import DateSelectorWithTimezone from "../components/DateSelectorWithTimezone";
import { useModalProvider } from "../providers/ModalProvider";
import ErrorModal from "../components/modal_contents/ErrorModal";
import moment from "moment";
import * as Yup from "yup";
import { useCallback, useEffect, useState, useRef } from "react";
import { nanoid } from "nanoid";
import DocumentUploader from "../components/DocumentUploader";
import VersionizerWrapper from "../components/Versionizer";
import { Radio, Checkbox } from "antd";
import BulkPhotos from "../components/BulkPhotos";
import Description from "../components/Description";
import { FileUpload } from "../components/FileUpload";
import UploadIcon from "../assets/icons/upload.png";
import FileUploader from "../components/FileUploader";
import { DONE } from "./onboarding_config/config";
import CopyIcon from "../components/CopyIcon";
import { IsSameVersion } from "./useVersionizer";
import ProfileList from "../pages/ProfilesList";

const disabledDate = (current) => {
  return current && current < moment().endOf("day");
};

export const validations = {
  str_255: Yup.string().max(255, "Maximum 255 Characters"),
  str_blob: Yup.string().max(65535, "Maximum 65,535 Characters"),
  str_req_blob: Yup.string().transform((value) => (value ? value.trim() : value)).max(65535, "Maximum 65,535 Characters").required('Required'),
  str_req_10: Yup.string()
    .max(10, "Maximum 10 Characters")
    .required("Required"),
  str_req_11: Yup.string()
    .max(11, "Maximum 11 Characters")
    .required("Required"),
  str_notreq_10: Yup.string().max(10, "Maximum 10 Characters"),
  str_notreq_20: Yup.string().max(20, "Maximum 20 Characters"),
  str_multiline: Yup.string(),
  str_18: Yup.string().max(18, "Maximum 18 Characters"),
  str_20: Yup.string().max(20, "Maximum 20 Characters"),
  str_req_20: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(20, "Maximum 20 Characters")
    .required("Required"),
  str_req_25: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(25, "Maximum 25 Characters")
    .required("Required"),
  str_notreq_25: Yup.string().max(25, "Maximum 25 Characters"),
  str_req_30: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(30, "Maximum 30 Characters")
    .required("Required"),
  str_notreq_30: Yup.string().max(30, "Maximum 30 Characters"),
  str_req_35: Yup.string().transform((value) => (value ? value.trim() : value)).max(35, "Maximum 35 Characters").required("Required"),
  str_notreq_35: Yup.string().max(35, "Maximum 35 Characters"),
  str_notreq_40: Yup.string().max(40, "Maximum 40 Characters"),
  str_req_40: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(40, "Maximum 40 Characters")
    .required("Required"),
  str_req_45: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(45, "Maximum 45 Characters")
    .required("Required"),
  str_notreq_50: Yup.string().max(50, "Maximum 50 Characters"),
  str_req_50: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(50, "Maximum 50 Characters")
    .required("Required"),
  str_req_60: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(60, "Maximum 60 Characters")
    .required("Required"),
  str_notreq_60: Yup.string().max(60, "Maximum 60 Characters"),
  str_req_70: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(70, "Maximum 70 Characters")
    .required("Required"),
  str_notreq_75: Yup.string().max(75, "Maximum 75 Characters"),
  str_notreq_100: Yup.string().max(100, "Maximum 100 Characters"),
  str_req_100: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(100, "Maximum 100 Characters")
    .required("Required"),
  str_req_255: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(255, "Maximum 255 Characters")
    .required("Required"),
  str_req_4000: Yup.string().max(4000, "Maximum 4000 Characters"),
  short_text: Yup.string().max(30, "Maximum 30 Characters"),
  short_text_required: Yup.string()
    .transform((value) => (value ? value.trim() : value))
    .max(30, "Maximum 30 Characters")
    .required("Required"),
  long_text: Yup.string().max(255, "Maximum 255 Characters"),
  long_text_required: Yup.string().transform((value) => (value ? value.trim() : value)).required("Required"),
  bool: Yup.boolean().nullable(),
  sort_order: Yup.number()
    .typeError("Must be a number")
    .integer()
    .min(0, "Minimum Sort Order: 0")
    .max(500, "Maximum Sort Order: 500"),
  drip_sequence: Yup.number()
    .typeError("Must be a number")
    .integer()
    .min(0, "Minimum Sort Order: 0")
    .max(100, "Maximum Sort Order: 100"),
  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .max(20, "Maximum 20 characters")
    .matches(/(?=.*[A-Z])/, {
      message: "Must contain 1 uppercase",
    })
    .matches(/([^A-Za-z0-9])/, {
      message:
        "Must contain 1 special character. Only the following special characters are allowed: -+_!@#$%^&*,.?</:",
    })
    .matches(/^[A-Za-z0-9\+\-\_\!\@\#\$\%\^\&\*\,\.\?\<\/\:]/, {
      message:
        "Invalid special character. Only the following special characters are allowed: -+_!@#$%^&*,.?</:",
    }),
  username: Yup.string() //
    .max(30, "Maximum 30 characters")
    .matches(/^\S*$/, {
      message: "No space",
    })
    .required("Required"),
  url: Yup.string().url("Please enter a valid URL"),
  url_req: Yup.string().url("Please enter a valid URL").required("Required"),
  long_url: Yup.string()
    .url("Please enter a valid URL")
    .max(255, "Maximum 255 Characters"),
  long_url_required: Yup.string()
    .url("Please enter a valid URL")
    .max(255, "Maximum 255 Characters")
    .required("Required"),
  email: Yup.string()
    .email('Enter a valid Email Address eg: yourname@gmail.com')
    .max(255, "Maximum 255 Characters")
    .required('Required'),
  email_not_required: Yup.string()
    .email('Enter a valid Email Address eg: yourname@gmail.com')
    .max(255, "Maximum 255 Characters"),
  website: Yup.string()
    .matches(
      /^(https?:\/\/)?([^\s]+\.[^\s]+)/,
      'Enter a valid website. (eg: www.domain.com)'
    )
    .max(255, "Maximum 255 characters")
    .required('Required')
};

const customFields = (field, props) => {
  const fields = {
    text: <Input {...props} />,
    textarea: <TextArea {...props} type="text" />,
    checkbox: <CheckBox {...props} />,
    richtext: <RichText {...props} type="text" rows={21} />,
    tickbox: <Tickbox {...props} />
  };
  return fields[field];
};

export const SubTopicFeaturedContentRadioGroup = ({ formik, disabled, user }) => {
  const type = formik?.values?.content_type?.toLowerCase() || "video";
  const [videoValues, setVideoValues] = useState([]);
  const [articleValues, setArticleValues] = useState([]);
  const [lessonValues, setLessonValues] = useState([]);

  useEffect(() => {
    const loadResources = async () => {
      try {
        const [videosRes, articlesRes, lessonsRes] = await Promise.all([
          GetAppResource(user, "content/videos"),
          GetAppResource(user, "content/articles"),
          GetAppResource(user, "content/lessons"),
        ]);

        if (videosRes.ok) {
          const videoData = await videosRes.json();
          setVideoValues(videoData.data || []);
        }

        if (articlesRes.ok) {
          const articleData = await articlesRes.json();
          setArticleValues(articleData.data || []);
        }

        if (lessonsRes.ok) {
          const lessonData = await lessonsRes.json();
          setLessonValues(lessonData.data || []);
        }
      } catch (error) {
        console.error("Error loading resources:", error);
      }
    };

    formik.setFieldValue("content_type", type)
    
    loadResources();
  }, [user]);

  useEffect(() => {
    const contentIdValue = formik.values.content_id;
    if (contentIdValue) {
      formik.setFieldValue("name", contentIdValue.name);
    }
  }, [formik.values.content_id]);

  const getSelector = () => {
    switch (type) {
      case "video":
        return { label: "Video", values: videoValues };
      case "article":
        return { label: "Article", values: articleValues };
      case "lesson":
        return { label: "Lesson", values: lessonValues };
      case "action_list":
        return { label: "Action List", resourceEndpoint: "content/action_lists" };
      case "resource":
        return { label: "Resource", resourceEndpoint: "content/resources" };
      default:
        return null;
    }
  };

  const options = [
    { type: "video", label: "Video" },
    { type: "article", label: "Article" },
    { type: "lesson", label: "Lesson" },
    { type: "action_list", label: "Action List" },
    { type: "resource", label: "Resource" },
  ];

  const selected = getSelector();

  return (
    <Radio.Group
      className="flex flex-col ml-5"
      disabled={disabled}
      name="content_type"
      onChange={(event) => {
        const selectedType = event.target.value;

        // Resetting Content Type
        formik.setFieldValue("content_type", selectedType);
        formik.setFieldValue("content_id", "");
        formik.setFieldValue("name", "");
      }}
      value={type}
    >
      {options.map(({ type: optionType, label }) => (
        <div key={optionType}>
          <Radio value={optionType} disabled={disabled}>
            <span className="text-lg">{label}</span>
          </Radio>

          {type === optionType && selected && (
            <div className="ml-10 mt-2">
              <DataSelector
                name="content_id"
                formik={formik}
                label={selected.label}
                labelClassName="hidden"
                dataSet={
                  selected.values
                    ? selected.values.map((item) => ({
                        id: item.id,
                        name: item.title,
                      }))
                    : []
                }
                single
                singleSelectOnly
                withSearch
                noMarginBottom
                resourceEndpoint={selected.resourceEndpoint}
              />

              <div className="w-full mt-2">
                <Input
                  name="custom_text"
                  type="text"
                  label="Custom Text"
                  required={true}
                  formik={formik}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </Radio.Group>
  );
};

export const ContentAndTitleSelector = ({ formik, user, platformVersion }) => {  
  const [topicsList, setTopicsList] = useState([]);
  const [endpointResult, setEndpointResult] = useState([]);
  const [loading, setLoading] = useState(false);

  const endpointCache = useRef({});

  useEffect(() => {
    fetchTopics();
  }, []);

  useEffect(() => {
    fetchTopics();
  }, [user.idToken]);

  useEffect(() => {
    const typeValue =
      typeof formik.values.content_type === "string"
        ? formik.values.content_type
        : formik.values.content_type?.value;

    if (!typeValue) {
      setEndpointResult([]);
      return;
    }

    // Special case handling
    const topic = topicsList.find(t => t.id === typeValue);
    const endpointKey = topic?.previousValue || typeValue;

    const endpoint = endpointCache.current[endpointKey.toLowerCase()];
    if (!endpoint) return;

    const fetchResources = async () => {
      try {
        setLoading(true);
        const res = await GetAppResource(user, endpoint);
        if (res.ok) {
          const data = await res.json();
          setEndpointResult(data.data || []);
        }
      } catch (err) {
        console.error("Error loading resources:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResources();
  }, [user, formik.values.content_type]);

  const fetchTopics = async () => {
    try {
      const cached = localStorage.getItem("topicsCache");
      if (cached) {
        const parsed = JSON.parse(cached);
        handleSpecialContentTypeToSet(formik.values.content_type, parsed.list || []);

        setTopicsList(parsed.list || []);
        endpointCache.current = parsed.map || {};
        return;
      }

      const res = await GetTopicContentsList(user.idToken);
      const data = await res.json();

      const formattedTopicsList = (data.contents || []).map((item) => ({
        ...item,
        id: item.name,
        previousValue: item.value
      }));

      handleSpecialContentTypeToSet(formik.values.content_type, formattedTopicsList)
      setTopicsList(formattedTopicsList);

      const map = formattedTopicsList.reduce((acc, item) => {
        if (item.value && item.resourceEndpoint) {
          acc[item.value.toLowerCase()] = item.resourceEndpoint;
        }
        return acc;
      }, {});

      endpointCache.current = map;

      localStorage.setItem(
        "topicsCache",
        JSON.stringify({ list: formattedTopicsList, map })
      );
    } catch (err) {
      console.error("Error fetching topics:", err);
    }
  };

  const handleSpecialContentTypeToSet = (formikContentType, list) => {
    const lowerCasedFormikContentType = formikContentType.toLowerCase();
    if (list.length > 0 &&
      (lowerCasedFormikContentType.includes("tip") || lowerCasedFormikContentType.includes("question") || lowerCasedFormikContentType.includes("flex"))
    ) {
      const topicContent = list.find((topic) => topic.value === formik.values.content_type.toLowerCase());

      formik.values.content_type = topicContent.name;
    }
  }

  return (
    <div>
      <div className="w-full ml-6 mt-2">
        <DataSelector
          single
          singleSelectOnly
          inSubtable
          name="content_type"
          formik={formik}
          label="Content"
          labelClassName="hidden"
          sortByName
          noMarginBottom
          dataSet={topicsList}
          required
          // valueKey="name"
        />
      </div>

      <div className="w-full ml-6">
        <DataSelector
          single
          singleSelectOnly
          name="content_id"
          formik={formik}
          label="Content Title"
          labelClassName="hidden"
          sortByName
          noMarginBottom
          dataSet={endpointResult}
          required
          onChange={(e) => {
            const selectedValue = e.target.value;

            if (selectedValue) {
              const id = e.target.value;
              const name = e.target.options[e.target.selectedIndex].label;

              if (platformVersion < 10.0) {
                formik.setFieldValue("content_id", { id, name });
              }

              if (platformVersion >= 10.0) {
                formik.setFieldValue("content_id", id);
                formik.setFieldValue("name", name);
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export const ProfileOption = ({ formik, user, platformVersion }) => {  
  const [profileList, setProfileList] = useState([]);

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const res = await GetAppResource(user, "profiles");
        if (res.ok) {
          const data = await res.json();

          const activeProfiles = (data.data || []).filter(
            (profile) => profile.active
          );

          setProfileList(activeProfiles);
        }
      } catch (err) {
        console.error("Error loading resources:", err);
      }
    };

    fetchResources();
  }, [user]);

  return (
    <div>
      <Radio value="Profile">
        <span className="text-lg">Profile</span>
      </Radio>
      {platformVersion >= 10.0 && formik?.values?.item_type === "Profile" && (
        <div>
          <div className="w-full ml-6 mt-2">
            <Input
              name="sort_order"
              type="number"
              label="Sort Order"
              formik={formik}
            />
          </div>
          {platformVersion >= 10.0 && (
            <div className="w-full ml-6 mt-2">
              <DataSelector
                single
                singleSelectOnly
                inSubtable
                valueKey="name"
                labelKey="name"
                placeholder="Select Profile"
                label="Profile List"
                name="name"
                dataSet={profileList}
                noMarginBottom
                formik={formik}
                onChange={(e) => {
                  const selected = profileList.find((item) => item.name === e.target.value);

                  if (selected) {
                    formik.setFieldValue("profile_id", selected.id);
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export const getState = (key) => {
  const strVal = localStorage.getItem(key);
  return strVal ? JSON.parse(strVal) : "";
};

export const setState = (key, value) => {
  if (value === undefined) return localStorage.removeItem(key);

  const val = JSON.stringify(value);
  localStorage.setItem(key, val);
};

export const hash = (str) => {
  const seed = 0;
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;

  String(str)
    .split("")
    .forEach((char) => {
      const ch = str.charCodeAt(char);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    });

  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export const categoryList = [
  'Games',
  'Business',
  'Education',
  'Lifestyle',
  'Entertainment',
  'Utilities',
  'Travel',
  'Health & Fitness',
  'Food & Drink',
  'Book',
  'Productivity',
  'Music',
  'Finance',
  'Photo & Video',
  'Sports',
  'Reference',
  'Social Networking',
  'News',
  'Medical',
  'Shopping'
]

export function useDuplicateValidation(
  keys = [],
  valuesKey = "sections",
  isShowModal = true
) {
  const { showModal } = useModalProvider();

  // clean up
  useEffect(() => {
    if (getState("formValuesRef")) localStorage.removeItem("formValuesRef");
    if (getState("payloadRef")) localStorage.removeItem("payloadRef");

    return () => {
      localStorage.removeItem("formValuesRef");
      localStorage.removeItem("payloadRef");
      localStorage.removeItem("formFieldRef");
    };
  }, []);

  const handleDuplicate = useCallback(async (key, values, formik) => {
    const formValueRef = getState("formValuesRef");
    const collections = values[valuesKey] || [];

    const collectionsValue = collections.map((s) =>
      String(s[key]).toLowerCase()
    );
    const collectionsSetValue = new Set(collectionsValue);

    if (collectionsSetValue.size !== collectionsValue.length) {
      let _collections = [...collections];

      // identify what row is updated
      const payloadRef = getState("payloadRef");

      // remove duplicate field in form
      if (!payloadRef && payloadRef !== 0) _collections.pop();
      else {
        // retain old state if value already existed
        _collections[payloadRef] = formValueRef[valuesKey][payloadRef];
      }

      formik.setFieldTouched(valuesKey, false, false);
      formik.setFieldValue(valuesKey, _collections, false);

      throw new Error("DUPLICATE");
    }
  }, []);

  return (values, formik) => {
    const formValueRef = getState("formValuesRef");
    const formFieldRef = getState("formFieldRef");

    // for validating of multiple fields
    if (formFieldRef !== valuesKey) return;

    // create reference to prev form value
    if (!formValueRef)
      localStorage.setItem(
        "formValuesRef",
        JSON.stringify(formik.initialValues)
      );

    // delays the execution in call stack to get updated payloadRef
    setTimeout(() => {
      Promise.all(keys.map((key) => handleDuplicate(key, values, formik)))
        .then(() => {
          // update reference to prev form value
          // upon no duplicate validation
          localStorage.setItem("formValuesRef", JSON.stringify(formik.values));
        })
        .catch((e) => {
          if (isShowModal) {
            showModal(<ErrorModal status="DUPLICATE" />);
            return;
          }
        });
    });
  };
}

export const getUuidFromString = (value) => {
  return value?.match?.(
    /[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
  )?.[0];
}

export const getFieldComponent = (
  name,
  {
    label,
    formik,
    selectedValues,
    formField,
    metadata,
    contentType,
    format,
    width,
    placeholder,
    disabled = false,
    user,
    isFieldRow = false,
    rows,
    required = false,
    isEnterprise = false,
    maxSize,
    isInlineNotReverse = false,
    ...fieldProps
  },
  quillName = name,
  customComponent = undefined
) => {
  const platformVersion = parseFloat(user?.app_data?.about?.platform_version);
   // Subtopics for the Topics page only — "Profile" is currently excluded
   const subTopics = user?.app_data?.setup?.available_sub_topics?.filter(
    (subTopic) => subTopic.id !== "Profile"
  );
  const categoriesRef = getState("categoriesRef") ? JSON.parse(getState("categoriesRef")) : [];
  const isEnabledListing = getState("isEnabledListing");

  const disableVideoURL =
    formik?.values?.type === "Card" && contentType === "items";

  const {  error: errorLogo } = getNestedFieldStatus(
    "privacy_policy_document",
    formik
  );

  const pathname = window.location.pathname;
  
  if (formField) {
    const field = customFields(formField, {
      label,
      formik,
      name,
      placeholder,
      isFieldRow,
      required,
      rows,
      isInlineNotReverse,
      disabled,
      ...fieldProps
    });
    return field;
  }

  if (name === "subtopic_type") {
    if (!formik.values.item_type) {
      formik.values.item_type = "ContentSubtopic";
    }
  
    if (!formik.values.sort_order) {
      formik.values.sort_order = 0;
    }
  }

  const fieldMap = {
    title: <Input name="title" type="text" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} />,
    host_name: (
      <Input name="host_name" type="text" label={label} formik={formik} />
    ),
    type: (
      <Select name="type" label={label} formik={formik}>
        <option value="">- Select {label} -</option>
        <option value="Card">Card</option>
        <option value="Book">Book/Video</option>
      </Select>
    ),
    tagged_visible: (
      <CheckBox
        name="tagged_visible"
        label={label}
        formik={formik}
        disabled={disabled}
      />
    ),
    email: <Input name={name} type="email" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} />,
    apple_dev_email: (
      <Input
        name={name}
        type="email"
        label={label}
        formik={formik}
        isFieldRow={isFieldRow}
        placeholder={placeholder} required={required}
      />
    ),
    google_dev_email: (
      <Input
        name={name}
        type="email"
        label={label}
        formik={formik}
        isFieldRow={isFieldRow}
        placeholder={placeholder} required={required}
      />
    ),
    "profile.id": (
      <DataSelector
        single
        singleSelectOnly
        inSubtable
        name="profile.id"
        formik={formik}
        label={label}
        resourceEndpoint="profiles"
      />
    ),
    "free_gift.url": (
      <Input name="free_gift.url" type="text" label={label} formik={formik} />
    ),
    "free_gift.image_url": (
      <MediaUploader
        name="free_gift.image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
      />
    ),
    "free_gift.description": (
      <TextArea
        name="free_gift.description"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    "vip_gift.url": (
      <Input name="vip_gift.url" type="text" label={label} formik={formik} />
    ),
    "vip_gift.registration_url": (
      <Input
        name="vip_gift.registration_url"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    "vip_gift.image_url": (
      <MediaUploader
        name="vip_gift.image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
      />
    ),
    "vip_gift.description": (
      <TextArea name="vip_gift.description" label={label} formik={formik} />
    ),
    message_prompt: (
      <TextArea
        name="message_prompt"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    download_url: (
      <Input name="download_url" type="text" label={label} formik={formik} />
    ),
    start_number: (
      <Input name="start_number" type="number" label={label} formik={formik} />
    ),
    end_number: (
      <Input name="end_number" type="number" label={label} formik={formik} />
    ),
    text:
      label === "Item Text" ? (
        <Input name={name} type="text" label={label} formik={formik} />
      ) : (
        <TextArea name="text" type="text" label={label} formik={formik} />
      ),
    web_text: (
      <RichText
        name="text"
        quillName="web_text"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    info: <Input name="info" type="text" label={label} formik={formik} />,
    name: <Input name="name" type="text" label={label} formik={formik} placeholder={placeholder} isFieldRow={isFieldRow} required={required} />,
    question: (
      <TextArea name="question" type="text" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} />
    ),
    headline: (
      <TextArea name="headline" type="text" label={label} formik={formik} />
    ),
    answer: (
      <TextArea name="answer" type="text" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} />
    ),
    url: <Input name="url" type="text" label={label} formik={formik} />,
    url_tag: <Input name="url_tag" type="text" label={label} formik={formik} />,
    use_url_tag: <CheckBox name="use_url_tag" label={label} formik={formik} />,
    link: <Input name="link" type="text" label={label} formik={formik} />,
    video_url: (
      <>
        <MediaUploader
          name="video_url"
          type="text"
          label={label}
          formik={formik}
          metadata={metadata}
          mediaType="video"
          disabled={disableVideoURL}
        />
      </>
    ),
    host_image_url: (
      <MediaUploader
        name="host_image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
      />
    ),
    content_screen_video_url: (
      <MediaUploader
        name="content_screen_video_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="video"
      />
    ),
    image_url: (
      <MediaUploader
        name="image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
        placeholder={placeholder}
        required={required}
        maxSize={maxSize}
        uploadLabelModifier="font-bold"
      />
    ),
    blog_image_url: (
      <div className="flex mb-3">
        <div className="w-1/3">
          <p className="text-lg">{label} {required && <span style={{ color: "red" }}> *</span>}</p>
        </div>
        <div className="w-2/3">
          <MediaUploader
            name="image_url"
            type="text"
            formik={formik}
            metadata={metadata}
            mediaType="image"
            placeholder={placeholder}
            required={required}
            maxSize={maxSize}
            uploadLabelModifier="font-bold"
          />
          <div className="text-base mt-2 mb-5 font-bold">
            ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
            &nbsp;for free commercial images.
          </div>
        </div>
      </div>
    ),
    audio_url: (
      <MediaUploader
        name="audio_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="audio"
      />
    ),
    document_section_url: (
      <div>
        <MediaUploader
          name="document_section_url"
          type="text"
          label={label}
          formik={formik}
          metadata={metadata}
          mediaType={platformVersion >= 8.5 ? "file" : "pdf"}
        />
        <div
          className="text-sm italic mb-3"
          style={{
            marginTop: -12,
          }}
        >
          {platformVersion >= 9.0
            ? "The ff. formats are accepted (pdf, doc, docx, txt, ppt, pptx, xls, xlsx)"
            : "The ff. formats are accepted: pdf, doc, docx, txt, ppt, pptx, xls, xlsx; however it will only display for apps on Platform Version 9.0 & up and WEB"}
        </div>
      </div>
    ),
    access_url: (
      <Input name="access_url" type="text" label={label} formik={formik} />
    ),
    app_id: <Input name={'app_id'} type="text" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} disabled={disabled}/>,
    app_token: <Input name={'app_token'} type="text" label={label} formik={formik} isFieldRow={isFieldRow} placeholder={placeholder} required={required} disabled={disabled}/>,
    description: (
      <RichText
        id={`description-${nanoid()}`}
        name="description"
        quillName={quillName}
        type="text"
        label={label}
        rows={rows || 21}
        formik={formik}
        contentType={contentType}
        placeholder={placeholder}
        isFieldRow={isFieldRow}
      />
    ),
    sub_description: (
      <Input name="sub_description" type="text" label={label} formik={formik} />
    ),
    notes: <TextArea name="notes" type="text" label={label} formik={formik} />,
    message: (
      <TextArea name="message" type="text" label={label} formik={formik} />
    ),
    video_description: (
      <TextArea
        name="video_description"
        type="text"
        label={label}
        formik={formik}
        rows={rows}
        isFieldRow={isFieldRow}
        placeholder={placeholder}
        required={required}
      />
    ),
    journal_description: (
      <TextArea
        name="journal_description"
        type="text"
        label={label}
        formik={formik}
        isFieldRow={isFieldRow}
        required={required}
      />
    ),
    review_video_url: (
      <MediaUploader
        name="review_video_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="video"
      />
    ),
    review_image_url: (
      <MediaUploader
        name="review_image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
      />
    ),
    listing_image_url: (
      <MediaUploader
        name="listing_image_url"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="image"
      />
    ),
    send_to: (
      <Input name="send_to" type="email" label={label} formik={formik} />
    ),
    question_1: (
      <TextArea name="question_1" type="text" label={label} formik={formik} />
    ),
    question_2: (
      <TextArea name="question_2" type="text" label={label} formik={formik} />
    ),
    question_3: (
      <TextArea name="question_3" type="text" label={label} formik={formik} />
    ),
    question_4: (
      <TextArea name="question_4" type="text" label={label} formik={formik} />
    ),
    question_5: (
      <TextArea name="question_5" type="text" label={label} formik={formik} />
    ),
    journal_1: (
      <TextArea name="journal_1" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />
    ),
    journal_2: (
      <TextArea name="journal_2" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />
    ),
    journal_3: (
      <TextArea name="journal_3" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />
    ),
    journal_4: (
      <TextArea name="journal_4" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />
    ),
    journal_5: (
      <TextArea name="journal_5" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />
    ),
    journal_image_url: (
      <div className="flex mb-3">
        <div className="w-1/3">
          <p className="text-lg">{label}</p>
        </div>
        <div className="w-2/3">
          <MediaUploader
            name={name}
            type="text"
            formik={formik}
            metadata={metadata}
            mediaType="image"
            isUploadOnly
            uploadLabelModifier="font-bold"
          />
          <div className="text-base mt-2 mb-5 font-bold">
            ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
            &nbsp;for free commercial images.
          </div>
        </div>
      </div>
    ),
    topics: (
      <>
        {pathname.includes("tips") || pathname.includes("action-lists") ? (
          <VersionizerWrapper minVersion={9}>
            <DataSelector
              name="topics"
              formik={formik}
              label="Topics/Listings"
              resourceEndpoint="topics"
              sortByName="true"
            />

            {pathname.includes("action-lists") ? (
              <div className="italic mt-1 mb-2 -mt-4 text-right">
                Coming soon in WEB
              </div>
            ) : null}
          </VersionizerWrapper>
        ) : (
          <DataSelector
            name="topics"
            formik={formik}
            label="Topics/Listings"
            resourceEndpoint="topics"
            sortByName="true"
            required={required}
          />
        )}
      </>
    ),
    categories: (
      <>
        <VersionizerWrapper minVersion={10}>
          <DataSelector
            name="categories"
            formik={formik}
            label="Categories"
            resourceEndpoint="categories"
            sortByName="true"
            filterOptions={(options) => 
              options.filter((status) => status.active)
            }
          />
        </VersionizerWrapper>
      </>
    ),
    author: <Input name="author" type="text" label={label} formik={formik} isFieldRow={isFieldRow} required={required} />,
    price: <Input name="price" type="text" label="Price" formik={formik} />,
    release_date: (
      <DateSelectorWithTimezone
        name="release_date"
        type="text"
        label={label}
        formik={formik}
        format={format}
        timezone={user?.data.timezone}
      />
    ),
    start_date: (
      <DateSelector
        name="start_date"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    end_date: (
      <DateSelector name="end_date" type="text" label={label} formik={formik} />
    ),
    enroll_date: (
      <DateSelector
        name="enroll_date"
        type="text"
        label={label}
        formik={formik}
        format={format}
      />
    ),
    action_bar_text: (
      <Input
        name="action_bar_text"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    action_bar_text_enterprise: (
      <Input
        name="action_bar_text"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    action_bar_text_actionclip: (
      <div className="italic mt-1 text-right">
        <i>Will not display in ActionClip, only on regular video</i>
      </div>
    ),
    enterprise_app: (
      <DataSelector
        name="enterprise_app"
        formik={formik}
        label={label}
        resourceEndpoint="children"
        filterOptions={(options) => {
          return options.filter((a) => a.active );
        }}
        single
        singleSelectOnly
        withSearch
      />
    ),
    action_bar_url: (
      <Input name="action_bar_url" type="text" label={label} formik={formik} />
    ),
    sort_order: (
      <Input name="sort_order" type="number" label={label} formik={formik} />
    ),
    active: (
      <CheckBox name="active" label={label} formik={formik} width={width} />
    ),
    auto_approve: (
      <div className="flex flex-col pt-2">
        <label className={`${width && "flex"} text-lg mb-3`} htmlFor="auto_approve">
          {label}
        </label>
        <div className="flex flex-row items-center gap-10">
          <CheckBox name="auto_approve_new" label='New submissions' formik={formik} width={width} disabled={disabled} isInline />
          <CheckBox name="auto_approve_edit" label='Edits to submissions' formik={formik} width={width} disabled={disabled} isInline />
        </div>
      </div>
    ),
    featured: (
      <CheckBox name="featured" label={label} formik={formik} width={width} />
    ),
    tags: (
      <DataSelector
        name="tags"
        formik={formik}
        label="Tags"
        resourceEndpoint="tags?category=Content"
        filterOptions={(values) => values.filter((a) => !a.is_expired)}
      />
    ),
    summit_tag: (
      <DataSelector
        single
        singleSelectOnly
        name="summit_tag.id"
        formik={formik}
        label="Summit Tag"
        resourceEndpoint="tags?category=Summit"
        filterOptions={(options) => {
          return options.filter((a) => !a.is_expired);
        }}
      />
    ),
    vip_tag: (
      <DataSelector
        single
        singleSelectOnly
        name="vip_tag.id"
        formik={formik}
        label="VIP Tag"
        resourceEndpoint="tags?category=Content"
        filterOptions={(options) => {
          return options.filter((a) => !a.is_expired);
        }}
      />
    ),
    course_name: (
      <DataSelector
        single
        singleSelectOnly
        keyOption="title"
        name="course_name"
        formik={formik}
        label="Course Name"
        resourceEndpoint="courses"
        sortByName
        filteredOptions={selectedValues}
        filterOptions={(options) => 
          options.filter((status) => status.active)
        }
      />
    ),
    cost: <Input name="cost" type="text" label={label} formik={formik} />,
    frequency: (
      <Select name={name} label={label} formik={formik} required={true}>
        <option value="">- Select {label} -</option>
        <option value="Once">Once</option>
        <option value="Daily">Daily</option>
        <option value="Weekly">Weekly</option>
        <option value="Custom">Custom</option>
      </Select>
    ),
    custom_frequency: (
      <div className="flex flex-col mb-5">
        <label className="text-lg mb-3">{label}</label>
        <CheckboxGroup
          formik={formik}
          name={name}
          children={["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]}
        />
      </div>
    ),
    journal_list: <CheckBox name={name} label={label} formik={formik} />,
    short_description: (
      <Input
        name="short_description"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    has_details: <CheckBox name={name} label={label} formik={formik} />,
    drawer_sub_description: (
      <Input name="description" type="text" label={label} formik={formik} />
    ),
    rss_url: (
      <Input
        name={name}
        type="text"
        label={label}
        formik={formik}
        placeholder={placeholder}
      />
    ),
    web_url: (
      <Input
        name={name}
        type="text"
        label={label}
        formik={formik}
        placeholder={placeholder}
        isFieldRow={isFieldRow}
      />
    ),
    document_url: (
      <>
        <DocumentUploader
          name={name}
          label={label}
          formik={formik}
          acceptedTypes={"text/plain, application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/txt,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
          metadata={metadata}
        />
        <div style={{ marginTop: 0 }} className="text-right mb-4">
          <i>
            {contentType === "documents" && platformVersion >= 9.0
              ? "The ff. formats are accepted (pdf, doc, docx, txt, ppt, pptx, xls, xlsx)"
              : "The ff. formats are accepted: pdf, doc, docx, txt, ppt, pptx, xls, xlsx; however it will only display for apps on Platform Version 9.0 & up and WEB"}
          </i>
        </div>
      </>
    ),
    form_type: (
      <Select
        name="form_type"
        label={label}
        formik={formik}
        disabled={disabled}
      >
        <option value="">- Select {label} -</option>
        <option value="Topic">Listing</option>
        <option value="Profile">Profile</option>
        <option value="Offer">Special Offer</option>
      </Select>
    ),
    actionform_description: (
      <TinyEditor
        name="actionform_description"
        type="text"
        label={label}
        formik={formik}
      />
    ),
    submit_link: (
      <Input name="submit_link" type="text" label={label} formik={formik} />
    ),
    link_expiry_date: (
      <>
        <DateSelector
          name="link_expiry_date"
          type="text"
          label={label}
          formik={formik}
          format={format}
        />
        {pathname.includes("action-forms") && (
          <div style={{ marginTop: -12 }} className="text-right mb-4">
            <i>
              Default is 90 days. You can extend or shorten this in the above
              field
            </i>
          </div>
        )}
      </>
    ),
    directories: (
      <DataSelector
        name="directories"
        formik={formik}
        label="Which Directory?"
        resourceEndpoint="directories"
        withLegend={isEnterprise}
        filterOptions={(!isEnterprise) ? (values) => values.filter((a) => !a.enterprise): (values) => values}
      />
    ),
    cta: (
      <DataSelector
        name="cta"
        formik={formik}
        label="Call to Action Name List"
        resourceEndpoint="call_to_actions"
        single
        singleSelectOnly
        withSearch
        filterOptions={(platformVersion < 10.0) ? (values) => values.filter((a) => a.cta_type !== "Content CTA"): (values) => values}
        sortByName
      />
    ),
    actionclip: (
      <>
        <VersionizerWrapper minVersion={9}>
          <CheckBox name="actionclip" label={label} formik={formik} />
        </VersionizerWrapper>
      </>
    ),
    actionclip_description: (
      <>
        <VersionizerWrapper minVersion={9}>
          <Input
            name="actionclip_description"
            type="text"
            label={label}
            formik={formik}
          />
        </VersionizerWrapper>
      </>
    ),
    directory_type: (
      <div className="flex flex-row w-full justify-between">
        <label
          className={`text-lg mb-5 w-1/3`}
          htmlFor={name}
        >
          {label}
        </label>
        <Radio.Group
          formik={formik}
          className="flex flex-row w-2/3"
          disabled={disabled}
          value={formik?.values?.directory_type ?? ""}
        >
          <Radio
            value="experts"
            disabled={disabled}
          >
            Experts
          </Radio>
          <Radio
            value="resources"
            disabled={disabled}
          >
            Resources
          </Radio>
        </Radio.Group>
      </div>
    ),
    "youtube_or_vimeo": (
      <MediaUploader
        name="youtube_or_vimeo"
        type="text"
        label={label}
        formik={formik}
        metadata={metadata}
        mediaType="video"
        disabled={disableVideoURL}
        placeholder={placeholder}
        required={required}
        isUrlOnly
        isErrorMessageBelowField
        uploadLabelModifier="font-bold"
      />
    ),
    gallery_description: customFields('textarea', { label, formik, name, placeholder, isFieldRow, rows, required }),
    photos: (
      <div className="w-full flex flex-row mt-5">
        <div className="w-1/3">
          <p className="text-lg">
            Gallery Image
            {required && <span style={{ color: "red" }}> *</span>}
          </p>
        </div>
        <div className="my-4 w-2/3">
          <BulkPhotos formik={formik} isUploadOnly fileType="image" uploadLabelModifier="font-bold" />

          {formik?.values?.photos?.length > 0 && (
            <div className="mt-5">
              <h2 className="font-bold text-lg">Uploaded</h2>

              {formik.values.photos.map((photo) => {
                return Object.values(photo.media_metadata).map((value) => {
                  return (
                    <li key={value.id} className="mt-2 flex">
                      <button
                        type="button"
                        className="ml-2"
                        onClick={() => {
                          formik.setFieldValue('photos', formik?.values.photos.filter((photoVal) => photoVal.id !== photo.id))
                        }}
                      >
                        <DeleteIcon className="mr-2 h-5 w-5 fill-current text-gray-400 trash hover:text-red-600" />
                      </button>
                      {value.filename}
                    </li>
                  )
                })
              })}
            </div>
          )}

          <div className="text-base mt-2 mb-5 font-bold">
            ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
            &nbsp;for free commercial images.
          </div>
        </div>
      </div>
    ),
    will_use_business_name: (
      <div className="flex justify-end mb-5">
        <div className="my-4 w-2/3">
          <Checkbox 
            id={name}
            name={name}
            onChange={(event) => {
              formik.setFieldValue('will_use_business_name', event.target.checked)

              if (!event.target.checked) formik.setFieldValue('profile_name', "")
            }}
            checked={formik.values.will_use_business_name}
          />
          <label htmlFor={name} className="text-lg ml-2"> {label}</label>
        </div>
      </div>
    ),
    profile_image_url: (
      <div className="flex">
        <div className="w-1/3">
          <p className="text-lg">{label}</p>
        </div>
        <div className="w-2/3">
          <MediaUploader
            name={name}
            type="text"
            formik={formik}
            metadata={metadata}
            mediaType="image"
            isUploadOnly
          />
        </div>
      </div>
    ),
    onboarding_profile_image_url: (
      <div className="flex">
        <div className="w-1/3">
          <p className="text-lg">{label} {required && <span style={{ color: "red" }}>*</span>}</p>
        </div>
        <div className="w-2/3">
          <MediaUploader
            name={name}
            type="text"
            formik={formik}
            metadata={metadata}
            mediaType="image"
            isUploadOnly
            uploadLabelModifier="font-bold"
          />
        </div>
      </div>
    ),
    business_name: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    profile_name: customFields('text', { label, formik, name, placeholder, isFieldRow, required, disabled: formik.values.will_use_business_name }),
    bio: (
      <div className="mt-6">
        {customFields('textarea', { label, formik, name, placeholder, isFieldRow, rows, required })}
      </div>
    ),
    facebook_url: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    twitter_url: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    instagram_url: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    linkedin_url: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    youtube_url: customFields('text', { label, formik, name, placeholder, isFieldRow }),
    welcome_media_type: (
      <>
        <div className="flex flex-row w-full justify-between mb-5">
          <label
            className={`text-lg mb-5 w-1/3`}
            htmlFor={name}
          >
            {label}
            {required && label !== "Welcome Image or Video" && <span style={{ color: "red" }}> *</span>}
          </label>
          <div className="w-2/3">
            <Radio.Group
              name={name}
              className="flex flex-row"
              formik={formik}
              disabled={disabled}
              onChange={formik.handleChange}
              value={formik?.values?.welcome_media_type}
            >
              <Radio
                className="text-base mr-10"
                value="image"
                disabled={disabled}
              >
                Welcome Image
              </Radio>
              <Radio
                className="text-base"
                value="video"
                disabled={disabled}
              >
                Welcome Video (Link)
              </Radio>
            </Radio.Group>
            <p className="mt-3 text-base text-black font-bold">^ You can display EITHER a Welcome Image OR Video</p>
          </div>
        </div>
        {formik.values.welcome_media_type === 'image' && (
          <div className="flex">
            <div className="w-1/3">
              <p className="text-lg">Welcome/Banner Image {required && <span style={{ color: "red" }}> *</span>}</p>
            </div>
            <div className="w-2/3">
              <MediaUploader
                name="image_url"
                type="text"
                formik={formik}
                metadata={metadata}
                mediaType="image"
                isUploadOnly
                uploadLabelModifier="font-bold"
              />
              <div className="text-base mt-2 mb-5 font-bold">
                ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
                <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
                <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
                &nbsp;for free commercial images.
              </div>
            </div>
          </div>
        )}
        {formik.values.welcome_media_type === 'video' && (
          <MediaUploader
            name="video_url"
            type="text"
            label="Welcome Video (Link)"
            formik={formik}
            metadata={metadata}
            placeholder="Welcome/ Explainer video (public unlisted YouTube/ Vimeo links ONLY)"
            mediaType="video"
            isUrlOnly
            required={required}
            isErrorMessageBelowField
          />
        )}
      </>
    ),
    welcome_message: (
      <TextArea name={name} type="text" label={label} formik={formik} placeholder={placeholder} rows={4} isFieldRow={isFieldRow} required={required} />
    ),
    topic: (
      <>
        <Input
          name={name}
          type="text"
          label={label}
          formik={formik}
          isFieldRow={isFieldRow}
          placeholder={placeholder}
          required={required}
        />
        <div className="flex">
          <div className="w-1/3">
            <p className="text-lg">Topic Icon</p>
          </div>
          <div className="w-2/3">
            <MediaUploader
              name="image_url"
              type="text"
              formik={formik}
              metadata={metadata}
              mediaType="image"
              isUploadOnly
              uploadLabelModifier="font-bold"
            />
            <div className="text-base mt-2 mb-5 font-bold">
              ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
              <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
              <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
              &nbsp;for free commercial images.
            </div>
          </div>
        </div>
      </>
    ),
    app_name: (
      <Input
        name="app_name"
        type="text"
        label={label}
        formik={formik}
        isFieldRow={isFieldRow}
        placeholder={placeholder}
        disabled={true}
        required={required}
      />
    ),
    in_app_name: (
      <>
        <div className="flex">
          <div className="w-1/3">
            <p className="text-lg">
              In-App Name <span style={{ color: "red" }}> *</span>
            </p>
          </div>
          <div className="w-2/3">
            <Input
              name="in_app_name"
              type="text"
              label={label}
              formik={formik}
              isFieldRow={isFieldRow}
              placeholder={placeholder}
              disabled={disabled}
            />
            <p className="w-full text-sm text-black mb-8 text-left font-bold">
              ^ Usually the same name as the App Store name (left image, above)
            </p>
          </div>
        </div>
      </>
    ),
    app_icon_name: (
      <>
        <div className="flex">
          <div className="w-1/3">
            <p className="text-lg">
              App Icon Name <span style={{ color: "red" }}> *</span>
            </p>
          </div>
          <div className="w-2/3">
            <Input
              name="app_icon_name"
              type="text"
              label={label}
              formik={formik}
              isFieldRow={isFieldRow}
              placeholder={placeholder}
              disabled={disabled}
            />
            <p className="w-full text-sm text-black mb-8 text-left font-bold">
              ^ 11 characters only, with spaces (right image, above)
            </p>
          </div>
        </div>
      </>
    ),
    short_app_description: (
      <Input
        name="short_app_description"
        type="text" label={label}
        formik={formik}
        isFieldRow={isFieldRow}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
      />
    ),
    full_app_description: (
      <TextArea
        name="full_app_description"
        type="text"
        label={label}
        formik={formik}
        placeholder={placeholder}
        isFieldRow={isFieldRow}
        required={required}
        disabled={disabled}
      />
    ),
    primary_category: [
      <Select
        name="primary_category"
        label={label}
        formik={formik}
        disabled={disabled}
        isFieldRow={isFieldRow}
        required={required}
        defaultValue=""
      >
        <option value="" disabled>
          Main store category for your App (recommend 'Education' of 'Lifestyle')
        </option>
        {categoryList.map(category => (
          <option key={Math.random()} value={category}>{category}</option>
        ))}
      </Select>
    ],
    secondary_category: [
      <Select
        name="secondary_category"
        label={label}
        formik={formik}
        disabled={disabled}
        isFieldRow={isFieldRow}
        required={required}
        defaultValue=""
      >
        <option value="" disabled>Second Store category for your app</option>
        {categoryList.map(category => (
          <option key={Math.random()} value={category}>{category}</option>
        ))}
      </Select>
    ],
    search_keywords: (
      <>
        <div className="flex">
          <div className="w-1/3">
            <p className="text-lg">
              App Search Keywords <span style={{ color: "red" }}> *</span>
            </p>
          </div>
          <div className="w-2/3">
            <TextArea
              name="search_keywords"
              className="w-full"
              type="text"
              label={label}
              formik={formik}
              placeholder={placeholder}
              isFieldRow={isFieldRow}
              disabled={disabled}
            />
            <p className="-mt-2 text-sm text-black mb-8 font-bold">
              ^ Don’t include both plurals & singulars; don’t add category names or include your App name again;
              avoid unauthorized trademarks, competitor’s app names, celebrity names & offensive words
            </p>
          </div>
        </div>
      </>
    ),
    search_keywords_note: (
      <div
        className="flex flex-col gap-1 p-2 mt-3 mb-5"
        style={{
          background: "#f5f5f5",
          border: "1px solid #cccccc",
        }}
      >
        <p className="font-bold">
          NOTE: You can get ideas for keywords by researching your competitors.
        </p>
        <ul>
          <li className="list-disc ml-6">
            <a
                className="font-bold whitespace-nowrap underline hover:no-underline"
                style={{
                  color: "#3091CE"
                }}
                href="https://www.adjust.com/resources/guides/app-store-optimization"
                target="_blank"
                rel="noreferrer"
              >
                Learn how keywords can affect your app visibility
            </a>
            &nbsp;<span className="font-bold">(select 'Keywords' in the side menu)</span>
          </li>
          <li className="list-disc ml-6">
            <a
                className="font-bold whitespace-nowrap underline hover:no-underline"
                style={{
                  color: "#3091CE"
                }}
                href="https://trends.google.com/trends"
                target="_blank"
                rel="noreferrer"
              >
                Learn what is trending on Google
            </a>
          </li>
        </ul>
        {/* <p>
           <span className="font-bold">NOTE:</span> You can get ideas for keywords by researching your competitors (
           <a
              className="font-bold whitespace-nowrap underline hover:no-underline"
              style={{
                color: "#3091CE"
              }}
              href="https://www.adjust.com/blog/7-quick-tips-to-optimize-your-app-store-keywords/"
              target="_blank"
              rel="noreferrer"
            >
              about App Keywords
          </a>
          ).
        </p> */}
      </div>
    ),
    support_contact: (
      <div className="flex flex-row w-full mb-5">
        <label
          className={`text-lg mb-5 w-1/3`}
          htmlFor={name}
        >
          {label} {required && <span style={{ color: "red" }}> *</span>}
        </label>
        <div className="w-2/3">
          <Radio.Group
            name={name}
            formik={formik}
            className="flex flex-col"
            disabled={disabled}
            onChange={event => {
              formik.setFieldValue("support_contact", event.target.value);
            }}
            value={formik?.values?.support_contact}
          >
            <Radio
              value="Use my app’s 'Companion Website' profile (default)"
              disabled={disabled}
            >
              Use my app’s 'Companion Website' profile (default) 
            </Radio>
            <Radio
              value="I already have a contact page"
              disabled={disabled}
            >
              I already have a contact page
            </Radio>
          </Radio.Group>
          <p className="w-full text-sm text-black mt-3 text-left font-bold">
            ^ We build your Companion profile as part of your content
          </p>
          {!formik.values['support_contact']&& (
            <div className="text-red-600">{formik.errors['support_contact']}</div>
          )}
        </div>
      </div>
    ),
    support_contact_page: (
      <>
        {formik?.values?.support_contact === "I already have a contact page" && (
          <div className="flex flex-row w-full mb-5">
            <label
              className={`text-lg mb-5 w-1/3`}
              htmlFor={name}
            >
              {label} {required && <span style={{ color: "red" }}> *</span>}
            </label>
            <div className="w-2/3">
                <div>
                  <Input
                      name="support_contact_page"
                      type="text"
                      formik={formik}
                      isFieldRow={isFieldRow}
                      placeholder={placeholder}
                      disabled={disabled}
                    />
                </div>
                <p className="w-full text-sm text-black mt-3 text-left font-bold">
                  ^ For users who have questions or feedback regarding your App
                </p>
              </div>
          </div>
        )}
      </>
    ),
    companion_website: (
      <>
        {formik?.values?.support_contact === "Use my app’s 'Companion Website' profile (default)" && (
          <Input
            name="companion_website"
            type="text"
            label={label}
            formik={formik}
            isFieldRow={isFieldRow}
            placeholder={placeholder}
            disabled={true}
            required={required}
          />
        )}
      </>
    ),
    privacy_policy: (
      <div className="flex flex-row w-full mb-5">
        <label
          className={`text-lg mb-5 w-1/3`}
          htmlFor={name}
        >
          {label} {required && <span style={{ color: "red" }}> *</span>}
        </label>
        <div className="flex flex-col w-2/3">
          <Radio.Group
            name={name}
            formik={formik}
            className="flex flex-col"
            disabled={disabled}
            onChange={event => {
              formik.setFieldValue("privacy_policy", event.target.value);
              formik.setFieldTouched("privacy_policy");
            }}
            value={formik?.values?.privacy_policy}
          >
            <Radio
              value="Use my app’s 'Companion Website' (default)"
              disabled={disabled}
            >
              Use my app’s 'Companion Website' (default)
            </Radio>
            <Radio
              value="I already have a privacy policy page"
              disabled={disabled}
            >
              I already have a privacy policy page
            </Radio>
          </Radio.Group>
          <p className="w-full text-sm text-black mt-3 text-left font-bold">
            ^ You must add the following document’s content to a page on your website
          </p>
          {!formik.values['privacy_policy'] && (
            <div className="text-red-600">{formik.errors['privacy_policy']}</div>
          )}
        </div>
      </div>
    ),
    privacy_policy_page: (
      <div className="mb-5">
        {formik?.values?.privacy_policy === "I already have a privacy policy page" && (
          <div>
            <Input
                name="privacy_policy_page"
                type="text"
                label={label}
                formik={formik}
                isFieldRow={isFieldRow}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
              />
          </div>
        )}
      </div>
    ),
    privacy_policy_document: (
      <>
        {formik?.values?.privacy_policy === "Use my app’s 'Companion Website' (default)" && (
          <div className="flex flex-row w-full mb-5">
            <div className="w-1/3">
              {label} <span style={{ color: "red" }}>*</span>
            </div>
            <div className="w-2/3">
              <FileUpload
                onError={(err) => formik.setFieldError("privacy_policy_document", err)}
                error={errorLogo}
                errorMessage={
                  "Only doc docx rtf txt odt formats are allowed"
                }
                isButton={false}
                buttonClassName=""
                disabled={disabled}
                uploadLabelModifier="font-bold"
                acceptedTypes=
                  "text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/rtf, text/rtf, application/vnd.oasis.opendocument.text, .rtf, .txt, .doc, .docx, .odt"
                fileType=
                  "text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/rtf, text/rtf, application/vnd.oasis.opendocument.text"
                onChange={(val, metadata) => {
                  formik.setFieldValue("privacy_policy_document", val);
                  formik.setFieldTouched("privacy_policy_document");
                  if(metadata){
                    formik.setFieldValue('media_metadata', {
                      ...formik.values.media_metadata,
                      [metadata.id]: metadata
                    })
                  }
                }}
                metaData={formik.values.media_metadata}
                value={formik.values.privacy_policy_document}
              >
                <div className={`p-6 flex flex-row justify-between items-center bg-white ${disabled ? '' : 'text-aeblue-link underline hover:no-underline'}`}>
                  <div className="font-bold">Choose File(s)</div>
                  <div>
                    <div
                      className="p-4 rounded-full"
                      style={{
                        background: "#ebebeb",
                      }}
                    >
                      <img
                        src={UploadIcon}
                        alt="Upload File"
                        className="w-3 h-3"
                      />
                    </div>
                  </div>
                </div>
              </FileUpload>
            </div>
          </div>
        )}
      </>
    ),
    privacy_policy_note: (
      <div
        className="flex flex-row items-center gap-1 p-2 mt-3 mb-5"
        style={{
          background: "#f5f5f5",
          border: "1px solid #cccccc",
        }}
      >
        <a
          className="font-bold whitespace-nowrap underline hover:no-underline"
          href="https://drive.google.com/drive/folders/1Z1IDbnEBDN4F0tlHaIkD2hi9eZkae2IV"
          target="_blank"
          rel="noreferrer"
          style={{
            color: '#3091CE'
          }}
        >
          Download Privacy Policy&darr;:
        </a>
        <p>
          (Download the document, then change the&nbsp;
          <span style={{color: '#FF0000', fontWeight: 'bold'}}>RED</span> text in this document to your App's info).
        </p>
      </div>
    ),
    support_email: (
      <div className="flex flex-row w-full mb-5">
        <label
          className={`text-lg mb-5 w-1/3`}
          htmlFor={name}
        >
          {label} {required && <span style={{ color: "red" }}> *</span>}
        </label>
        <div className="w-2/3">
          <Input
            name="support_email"
            type="text"
            formik={formik}
            isFieldRow={isFieldRow}
            placeholder={placeholder}
            disabled={disabled}
          />
          <p className="w-full text-sm black text-left font-bold">
            ^ This can also be an email “forward”, or a free Gmail/other account
          </p>
          </div>
      </div>
    ),
    enterprise: (
      <CheckBox name="enterprise" label={label} formik={formik} />
    ),
    cta_type: (
      <div className="flex flex-row w-full justify-between pb-4">
        <label
          className={`text-lg mb-5`}
          htmlFor={name}
        >
          CTA Type
          <span style={{ color: "red" }}> *</span>
        </label>
        <Radio.Group
          formik={formik}
          className="flex flex-row"
          disabled={disabled}
          value={formik?.values?.cta_type ?? "URL CTA"}
          onChange={event => {
            formik.setFieldValue("cta_type", event.target.value)
            formik.setFieldValue("cta", null)
            formik.setFieldValue("action_bar_text", "")
            formik.setFieldValue("action_bar_url", "")
            formik.setFieldValue("enterprise_app", null)
          }}
        >
          <Radio
            value="URL CTA"
            disabled={disabled}
          >
            URL CTA
          </Radio>
          <Radio
            value="Preset CTA"
            disabled={disabled}
          >
            Preset CTA
          </Radio>
          {
            user?.app_data?.setup.enterprise_launch_business && !formik?.values?.actionclip
            && contentType !== "galleries"  ? (
              <Radio
                value="Launch Business"
                disabled={disabled}
              >
                Launch Business
              </Radio>
            ) : null
          }
        </Radio.Group>
      </div>
    ),
    article_image_url: (
      <div className="flex">
        <div className="w-1/3">
          <p className="text-lg pr-2">{label}</p>
        </div>
        <div className="w-2/3">
          <MediaUploader
            name={name}
            type="text"
            formik={formik}
            metadata={metadata}
            mediaType="image"
            isUploadOnly
            uploadLabelModifier="font-bold"
          />
          <div className="text-base mt-2 mb-5 font-bold">
            ^ Try <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://pixabay.com" target="_blank" rel="noreferrer">pixabay.com</a>,&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://unsplash.com" target="_blank" rel="noreferrer">unsplash.com</a> or&nbsp;
            <a className="text-aeblue-link text-base underline hover:no-underline hover:text-aeblue-link" href="https://www.flaticon.com" target="_blank" rel="noreferrer">flaticon.com</a>
            &nbsp;for free commercial images.
          </div>
        </div>
      </div>
    ),
    app_designed: (
      <div className="flex flex-row space-between mb-5">
        <div className="w-1/3">
          <p className="text-lg pr-2">{label}</p>
        </div>
        <div className="dropdown-select w-2/3">
          <select name={name} value={formik.values[name]} onChange={(evt) => formik.setFieldValue(name, evt.target.value)}>
            <option value="get_started" label="Get Started" />
            <option value="mockups_sent" label="Mockups Sent ✓" />
            <option value="approval" label="WAIT: Approval" />
            <option value="logo" label="WAIT: Logo" />
            <option value="reply" label="WAIT: Reply" />
            <option value="client" label="WAIT: Client" />
            <option value="meeting" label="WAIT: Meeting" />
            <option value="payment" label="WAIT: Payment" />
            <option value="hold" label="HOLD" />
            <option value={DONE} label="DONE ✓" />
          </select>
        </div>
      </div>
    ),
    app_designed_due_date: (
      <DateSelector
        name={name}
        type="text"
        label={label}
        formik={formik}
        isFieldRow
      />
    ),
    app_designed_assets_file: (
      <FileUploader
        label={label}
        name={name}
        required={required}
        errorMessage="You can only upload a .zip file"
        acceptedTypes="application/zip, application/x-zip-compressed, application/octet-stream"
        fileTypes="application/zip, application/x-zip-compressed, application/octet-stream"
        formik={formik}
        value={formik.values[name]}
        maximumFileSize={104857600}
        uploadLabelModifier="font-bold"
      />
    ),
    app_designed_graphics: (
      <>
        <FileUploader
          multiple
          label={label}
          name={name}
          required={required}
          errorMessage="Invalid file type. Pls upload a .zip file or an image file type"
          acceptedTypes="application/zip, application/x-zip-compressed, application/octet-stream, image/jpeg, image/png, image/jpg, image/gif, image/tiff, image/vnd.adobe.photoshop, application/pdf, application/postscript, application/postscript, application/x-indesign, image/x-sony-arw, image/x-canon-cr2, image/x-nikon-nef, image/x-olympus-orf, image/x-panasonic-raw, image/x-adobe-dng, image/svg+xml, image/bmp, image/webp, .indd, .raw, .psd, image/RAW"
          fileTypes="application/zip, application/x-zip-compressed, application/octet-stream, image/jpeg, image/png, image/jpg, image/gif, image/tiff, image/vnd.adobe.photoshop, application/pdf, application/postscript, application/postscript, application/x-indesign, image/x-sony-arw, image/x-canon-cr2, image/x-nikon-nef, image/x-olympus-orf, image/x-panasonic-raw, image/x-adobe-dng, image/svg+xml, image/bmp, image/webp, .indd, .raw, .psd, image/RAW"
          formik={formik}
          value={formik.values[name]}
          maximumFileSize={104857600}
          uploadLabelModifier="font-bold"
        />
      </>
    ),
    assets: (
      <FileUploader
        label={label}
        name={name}
        required={required}
        errorMessage="You can only upload a .zip file"
        acceptedTypes="application/zip, application/x-zip-compressed, application/octet-stream"
        fileTypes="application/zip, application/x-zip-compressed, application/octet-stream"
        formik={formik}
        value={formik.values[name]}
      />
    ),
    app_built: (
      <div className="flex flex-row space-between mb-5">
        <div className="w-1/3">
          <p className="text-lg pr-2">{label}</p>
        </div>
        <div className="dropdown-select w-2/3">
        <select name={name} value={formik.values[name]} onChange={(evt) => formik.setFieldValue(name, evt.target.value)}>
            <option value="get_started" label="Get Started" />
            <option value="create_ios_app" label="Create iOS App" />
            <option value="setup_firebase" label="Setup Firebase" />
            <option value="create_android_app" label="Create Android App" />
            <option value="meet_with_creator" label="Meet with Creator" />
            <option value="hold" label="HOLD" />
            <option value={DONE} label="DONE ✓" />
          </select>
        </div>
      </div>
    ),
    ios_p8_file: (
      <FileUploader
        label={label}
        name={name}
        required={required}
        errorMessage="You can only upload a .p8 file"
        acceptedTypes=".p8"
        fileTypes="text/plain"
        formik={formik}
        value={formik.values[name]}
        uploadLabelModifier="font-bold"
      />
    ),
    json_file: (
      <FileUploader
        label={label}
        name={name}
        required={required}
        errorMessage="You can only upload a .json file"
        acceptedTypes=".json, application/json"
        fileTypes="application/json"
        formik={formik}
        value={formik.values[name]}
        uploadLabelModifier="font-bold"
      />
    ),
    aab_file: (
      <FileUploader
        label={label}
        name={name}
        required={required}
        errorMessage="You can only upload a .AAB file"
        acceptedTypes=".aab, text/aab"
        fileTypes="text/aab"
        formik={formik}
        value={formik.values[name]}
        maximumFileSize={50000000}
        uploadLabelModifier="font-bold"
      />
    ),
    qrcode: (
      <div>
        <Input
          name={name}
          label={label}
          formik={formik}
          isFieldRow={isFieldRow}
          placeholder={placeholder}
          required={required}
        />

        <FileUploader
          label=""
          name="qrcode_file"
          required={required}
          errorMessage="You can only upload .jpeg, .jpg, or .png"
          acceptedTypes="image/jpeg, image/png, image/jpg"
          fileTypes="image/jpeg, image/png, image/jpg"
          formik={formik}
          value={formik.values.qrcode_file}
          uploadLabelModifier="font-bold"
        />
      </div>
    ),
    app_designed_web_url: (
      <div className="pb-4">
        <Input
          name={name}
          type="text"
          label={label}
          formik={formik}
          isFieldRow={isFieldRow}
          required={required}
          prefix="https://web.actionera.com/"
          inputClassName="items-center"
          prefixClassName="text-lg"
        />

        <div className={`w-full justify-end pb-4 ${formik.values.username ? "flex" : "hidden"}`}>
          <a
            className="underline"
            style={{
              color: "#1890ff",
            }}
            href={`${process.env.REACT_APP_WEB_FQDN}/${formik.values.username}`}
            target="_blank"
            rel="noreferrer"
          >
            {process.env.REACT_APP_WEB_FQDN}/{formik.values.username}
          </a>
          <CopyIcon
            value={`${process.env.REACT_APP_WEB_FQDN}/${formik.values.username}`}
          />
        </div>
      </div>
    ),
    apple_dev_password: (
      <Input disabled={disabled} name={name} type="password" label={label} formik={formik} isFieldRow={isFieldRow} />
    ),
    google_dev_password: (
      <Input disabled={disabled} name={name} type="password" label={label} formik={formik} isFieldRow={isFieldRow} />
    ),
    app_designed_assets_download_url: (
      <div className="w-full flex justify-between pb-4">
        <label className="text-lg mb-3 w-1/3">App Assets</label>
        {
          formik.values?.app_designed_assets_download_url?.length > 0 ? (
            <button
              type="button"
              onClick={async(e) => {
                e.preventDefault();
                e.stopPropagation();

                const uuid = getUuidFromString(formik?.values?.app_designed_assets_file);

                if (!uuid) { return; }

                const path = formik.values?.media_metadata[uuid]?.url;
                const filename = formik.values?.media_metadata[uuid]?.filename;
                const response = await fetch(path);
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
              }}
              className="cursor-pointer text-aeblue-link underline hover:no-underline w-2/3 flex justify-end font-bold"
            >
              {formik.values?.media_metadata[getUuidFromString(formik?.values?.app_designed_assets_file)]?.filename}
            </button>
          ) : <span>None</span>
        }
      </div>
    ),
    subtopic_type: (
      <div className="flex flex-col w-full mb-5">
        <Radio.Group
          formik={formik}
          name="item_type"
          className="flex flex-col"
          disabled={disabled}
          onChange={(event) => {
            formik.setFieldValue("item_type", event.target.value);
          }}
          value={formik?.values?.item_type}
        >
          {/* === Content Subtopic === */}
          <div>
            <Radio value="ContentSubtopic" disabled={disabled}>
              <span className="text-lg">Content Subtopic</span>
            </Radio>
            {formik?.values?.item_type === "ContentSubtopic" && (
              <div>
                {platformVersion >= 10.0 && (
                  <div className="w-full ml-6 mt-2">
                    <Input
                      name="sort_order"
                      type="number"
                      label="Sort Order"
                      formik={formik}
                    />
                  </div>
                )}
                <div className="w-full ml-6 mt-2">
                  <DataSelector
                    single
                    singleSelectOnly
                    inSubtable
                    name="name"
                    formik={formik}
                    placeholder="Select Subtopic Type"
                    label="Sub Topic"
                    labelClassName="hidden"
                    dataSet={subTopics}
                    noMarginBottom
                    required
                  />
                </div>
              </div>
            )}
          </div>

          {/* === Profile === */}
          {isEnabledListing && (
            <div>
              <ProfileOption
                formik={formik}
                user={user}
                platformVersion={platformVersion}
              />
            </div>
          )}
    
          {/* === Category === */}
          {platformVersion >= 10.0 && (   
            <div>
              <Radio value="Category" disabled={disabled}>
                <span className="text-lg">Category</span>
              </Radio>
              {formik?.values?.item_type === "Category" && (
                <div>
                  <div className="w-full ml-6 mt-2">
                    <Input
                      name="sort_order"
                      type="number"
                      label="Sort Order"
                      formik={formik}
                    />
                  </div>
                  <div className="w-full ml-6 mt-2">
                    <DataSelector
                      single
                      singleSelectOnly
                      inSubtable
                      valueKey="name"
                      placeholder="Select Category"
                      label="Category"
                      labelClassName="hidden"
                      name="name"
                      dataSet={categoriesRef}
                      noMarginBottom
                      formik={formik}
                      onChange={(e) => {
                        const selected = categoriesRef.find((item) => item.name === e.target.value);

                        if (selected) {
                          formik.setFieldValue("category_id", selected.id);
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
    
          {/* === Featured Content === */}
          <div>
            <Radio value="FeaturedContent" disabled={disabled}>
              <span className="text-lg">Featured Content</span>
            </Radio>
            {platformVersion < 10.0 && (
              <>
                {formik?.values?.item_type === "FeaturedContent" && (
                  <div>
                    <SubTopicFeaturedContentRadioGroup
                      formik={formik}
                      disabled={disabled}
                      user={user}
                    />
                  </div>
                )}
              </>
            )}
            
            {/* for platform version 10.0 */}
            {platformVersion >= 10.0 && formik?.values?.item_type === "FeaturedContent" && (
              <div>
                <div className="w-full ml-6 mt-2">
                  <Input
                    name="sort_order"
                    type="number"
                    label="Sort Order"
                    formik={formik}
                  />
                </div>
                <div className="w-full ml-6 mt-2">
                  <Input
                    name="custom_text"
                    type="text"
                    label="Custom Text"
                    required={true}
                    formik={formik}
                  />
                </div>
                <div>
                    <ContentAndTitleSelector
                      formik={formik}
                      user={user}
                      platformVersion={platformVersion}
                    />
                </div>
              </div>
            )}
            
          </div>
    
          {/* === Custom URL === */}
          <div>
            <Radio value="CustomUrl" disabled={disabled}>
              <span className="text-lg">Custom URL</span>
            </Radio>
            {formik?.values?.item_type === "CustomUrl" && (
              <div>
                {platformVersion >= 10.0 && (
                  <div className="w-full ml-6 mt-2">
                    <Input
                      name="sort_order"
                      type="number"
                      label="Sort Order"
                      formik={formik}
                    />
                  </div>
                )}
                <div className="w-full ml-6 mt-2">
                  <Input
                    name="url"
                    type="text"
                    label="Link"
                    formik={formik}
                  />
                </div>
                <div className="w-full ml-6">
                  <Input
                    name="name"
                    type="text"
                    label="Link Text"
                    formik={formik}
                  />
                </div>
              </div>
            )}
          </div>
        </Radio.Group>
      </div>
    ),
  };

  return fieldMap[name] || customComponent;
};
